import React, { useState } from "react";
import "./Navbar.scss";
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { motion } from "framer-motion";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const menuClikedOpen = () => setToggle(true);
  const menuClikedClose = () => setToggle(false);

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <h2>
          ABHI<span style={{ color: "#313bac" }}>SHEK</span>
        </h2>
      </div>

      <ul className="app__navbar-links">
        {["home", "about", "work", "skills", "contact"].map((el) => (
          <li className="app__flex p-text" key={`link-${el}`}>
            <div />
            <a href={`#${el}`}>{el}</a>
          </li>
        ))}
      </ul>

      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={menuClikedOpen} />

        {toggle && (
          <motion.div
            whileInView={{ x: [200, 0] }}
            transition={{ duration: 0.85, ease: "easeOut" }}
          >
            <HiX onClick={menuClikedClose} />
            <ul>
              {["home", "about", "work", "skills", "contact"].map((el) => (
                <li key={el}>
                  <a href={`#${el}`} onClick={menuClikedClose}>
                    {el}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
